import { StatusChip } from "components/StatusChip";
import { WasteInvoiceLineKind } from "generated-graphql/graphql";

import { LINE_KIND_LABELS } from "../utils";
const CHIP_SX = { maxWidth: "100%" };

export function InvoiceAuditChargeTypeCell({ kind }: { kind: WasteInvoiceLineKind }) {
  const label = LINE_KIND_LABELS[kind];
  return <StatusChip label={label} title={label} color="default" sx={CHIP_SX} />;
}

export function InvoiceAuditUnitCell({ unit }: { unit: string | null | undefined }) {
  return unit?.trim() ? unit : "—";
}
